// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a8a1437d","455":"e66c6e08","977":"8ddf9c74"}[chunkId] + ".chunk.js";
};